module.exports = __webpack_public_path__ + "img/eklavya.966c3bcb.jpg";